import BaseModel from './BaseModel';

export default class User extends BaseModel
{

    static getPrefix()
    {
        return 'trustup:user';
    }

    getName()
    {
        return `${this.first_name} ${this.last_name}`;
    }

    getFullName()
    {
        return this.getName();
    }

    getDisplayName()
    {
        return `${this.first_name} ${this.last_name.charAt(0)}.`;
    }

    is(user)
    {
        return this.id == user.id;
    }

}